import { useProductIdFormQueryString } from "../HeyLight/useProductIdFormQueryString.ts";
import { NormasTeachingProductCheckoutScreenInner } from "./NormasTeachingProduct/NormasTeachingProductCheckoutScreen.tsx";
import { useBundleIdFormQueryString } from "./NormasTeachingBundle/useBundleIdFormQueryString.ts";
import { NormasTeachingBundleCheckoutScreenInner } from "./NormasTeachingBundle/NormasTeachingBundleCheckoutScreen.tsx";

export const NormasTeachingCheckoutScreenPath =
  "/normasteachingproduct/checkout";

export function NormasTeachingCheckoutScreen() {
  const { productId } = useProductIdFormQueryString();
  const { bundleId } = useBundleIdFormQueryString();
  if (bundleId) {
    return <NormasTeachingBundleCheckoutScreenInner bundleId={bundleId} />;
  } else if (productId)
    return <NormasTeachingProductCheckoutScreenInner productId={productId} />;
  else return <p>Product not found</p>;
}
